export default __webpack_public_path__ + "static/media/tutorial6-3.afe25bd4.png";